/**
 * DateTransformer Util
 * Code taken from https://www.npmjs.com/package/axios-date-reviver
 * and modified to test all strings that being with "1" or "2".
 * We assume that all dates sent to us from our API begin with "1" or "2",
 * i.e. they are in the 1xxx or 2xxx millenia.
 */
const isFirstChar1Or2 = (str) => str[0] === "1" || str[0] === "2";
/**
 * Based on: https://www.regextester.com/112232
 */
const dateFormat = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d*)?(-\d{2}:\d{2}|Z)?$/;
function isValidDate(date) {
    return (date != null &&
        Object.prototype.toString.call(date) === "[object Date]" &&
        !isNaN(date));
}
/**
 * A function which evaluates whether a given key/value pair contains a date or time
 * and converts that value to a Date object if so
 * @param {string} key Key
 * @param {unknown} value Value to evaluate and revive
 * @returns {unknown | Date} the value, simply passed through if not a date, or a Date
 */
function dateReviver(key, value) {
    if (typeof value === "string" &&
        isFirstChar1Or2(value) &&
        dateFormat.test(value)) {
        const potentialDate = new Date(value);
        if (isValidDate(potentialDate)) {
            return potentialDate;
        }
    }
    return value;
}
function dateTransformer(data) {
    if (data === "") {
        return data;
    }
    // Attempt to parse the data as JSON
    // If it fails, return the data as-is
    // e.g. Blob data
    try {
        return JSON.parse(data, dateReviver);
    }
    catch (_a) {
        return data;
    }
}
export { dateTransformer };
